var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useCallback, useState } from 'react';
import { apiCreateClientSeminarView } from '@/actions/ClientSeminarActions';
import { apiGetListClientSeminar } from '@/actions/ClientSeminarActionsTs';
import { useClientSeminarSaveViewEvent } from '@/helpers/use/client_seminar/useClientSeminarSaveViewEvent';
import { wrapDispatch } from '@/utils/actions/dispatch';
import { REGISTRATION_TYPE_TOP_SEMINAR } from '@/utils/resources/registration/registrationType';
/**
 * セミナー情報を取得・制御するカスタムフック
 */
export const useClientTopPageSeminar = (options) => {
    const { changeFullScreenImages, changeRegistrationType, dispatch, isShowFullScreenImageViewer, showFullScreenImageViewer, showRegistrationFormModal, } = options;
    // フルスクリーン画像ビューワーに表示しているセミナーID
    const [seminarIdInFullScreenImageViewer, changeSeminarIdInFullScreenImageViewer,] = useState(null);
    // セミナー一覧のデータを保持するstate
    const [seminarList, changeSeminarList] = useState();
    // セミナー資料の閲覧ログ保存用のイベント
    const { onChangeDocumentImage } = useClientSeminarSaveViewEvent({
        dispatch,
        isShowDocumentModal: isShowFullScreenImageViewer,
        seminarId: seminarIdInFullScreenImageViewer,
    });
    /**
     * セミナー情報取得
     */
    const fetchSeminar = useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        const { payload } = yield wrapDispatch(dispatch, apiGetListClientSeminar({ query: {} }, {}));
        // 取得したデータをstateに保存
        changeSeminarList(payload.list);
    }), [dispatch, changeSeminarList]);
    /**
     * 資料表示ボタンをクリックした時の処理
     */
    const onClickDocumentLink = useCallback((e) => {
        var _a;
        const { value } = e.currentTarget;
        const id = parseInt(value, 10);
        // 検索結果から該当するセミナーを取得する
        const { information } = (seminarList === null || seminarList === void 0 ? void 0 : seminarList.find((v) => v.id === id)) || {};
        // セミナー情報から資料画像一覧を取得し、stateに保存
        const seminarImages = (((_a = information === null || information === void 0 ? void 0 : information.images) === null || _a === void 0 ? void 0 : _a.map((v) => v.path)) || []).filter((path) => typeof path === 'string');
        changeFullScreenImages(seminarImages);
        // フルスクリーン画像ビューワーに表示するセミナーIDを更新
        changeSeminarIdInFullScreenImageViewer(id);
        // フルスクリーン画像ビューワーを表示
        showFullScreenImageViewer();
    }, [changeFullScreenImages, seminarList, showFullScreenImageViewer]);
    /**
     * 資料表示ボタンをクリックした時の処理（ゲスト）
     */
    const onClickDocumentLinkByGuest = useCallback(() => {
        // 登録元種別を変更
        changeRegistrationType(REGISTRATION_TYPE_TOP_SEMINAR);
        // 新規登録モーダルを表示
        showRegistrationFormModal();
    }, [changeRegistrationType, showRegistrationFormModal]);
    /**
     * セミナー検索結果をクリックした時の処理
     */
    const onClickSeminarLink = useCallback((e) => {
        const { dataset } = e.currentTarget;
        const { result_id: resultId, text } = dataset;
        // ボタンリンクがどのテキストの時にクリックされた計測するため、閲覧履歴を保存
        dispatch(apiCreateClientSeminarView(resultId, { text }, {}));
    }, [dispatch]);
    return {
        fetchSeminar,
        onChangeDocumentImage,
        onClickDocumentLink,
        onClickDocumentLinkByGuest,
        onClickSeminarLink,
        seminarList,
    };
};
